<template>
    <v-container fluid>
        <div v-if="!dataLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Transfer Receipt Voucher</h4>
                    <p class="text-subtitle-1">Stock Transfer Receipt Voucher Form</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <TransferReceiptVoucherForm ref="form" v-model="data"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn class="primary" block @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn depressed block @click="handleCancel">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import TransferReceiptVoucherForm from '../../../components/warehouse/transfer/TransferReceiptVoucherForm.vue';
import PAlert from '../../../components/common/PAlert.vue';
import stockTransferReceiptAPI from './../../../services/stockJournal/stockTransferReceipt';
import stockTransferAPI from './../../../services/stockJournal/stockTransfer';
import { v4 as uuid } from 'uuid';
import moment from 'moment';

export default {
    components: {
        TransferReceiptVoucherForm,
        PAlert
    },
    data() {
        return {
            data: {},
            stockTransferId: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            loading: false,
            dataLoading: false,
            idempotentKey: null
        }
    },
    methods: {
        handleSave() {
            this.alert = {...this.alert, content: "Are you sure you want to save?", value: true, callback: this.save }
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            stockTransferReceiptAPI.create({...this.data, idempotentKey: this.idempotentKey}).then(response => {
                this.$router.replace({
                    name: "TransferReceiptVoucherDisplay",
                    params: {
                        id: response.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, content: "Are you sure you want to discard changes?", value: true, callback: this.cancel }
        },
        cancel() {
            this.$router.back();
        },
        fetchStockTransfer() {
            this.dataLoading = true;
            stockTransferAPI.find(this.stockTransferId).then(res => {
                this.data = {
                    date: moment().format("YYYY-MM-DD"),
                    source_warehouse: res.data.source_warehouse,
                    source_warehouse_id: res.data.source_warehouse.id,
                    target_warehouse: res.data.target_warehouse,
                    target_warehouse_id: res.data.target_warehouse.id,
                    stock_transfer_id: res.data.id,
                    stock_transfer_code: res.data.code,
                    lines: res.data.lines.map(line => {
                        return {
                            item: line.item,
                            item_id: line.item.id,
                            quantity: line.quantity,
                            measure_unit: line.measure_unit,
                            measure_unit_id: line.measure_unit.id,
                            price: line.price,
                            key: uuid()
                        }
                    })
                }
            }).finally(() => {
                this.dataLoading = false;
            })
        }
    },
    created() {
        this.idempotentKey = uuid();
        this.stockTransferId = this.$route.query.stock_transfer_id
        this.fetchStockTransfer();
    }
}
</script>